import { Stack, styled } from '@mui/material';

import { colors } from '../../components';

export const SettingsWrapper = styled(Stack)(({ theme }) => ({
    '& .tabWrapper': {
        width: '220px',
        minWidth: '220px',
        backgroundColor: colors.fullWhite,
        borderRadius: 8,
        padding: 16,
        '& .tabButton': {
            ...theme.typography.body2,
            justifyContent: 'flex-start',
            '&:hover': {
                backgroundColor: colors.primaryLight[100],
                color: colors.fullWhite,
                '& span': {
                    color: `${colors.fullWhite} !important`,
                },
            },
        },
    },
}));

export const MyProfileWrapper = styled(Stack)(({ theme }) => ({
    '& .avatarWrapper': {
        ...theme.typography.h2,
        width: 232,
        height: 232,
        backgroundColor: colors.primaryLight[15],
        fontWeight: 600,
        border: `16px solid ${colors.primaryLight[15]}`,
        '& .userImage': {
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center',
            display: 'block',
        },
    },
    '& .verifyButton': {
        position: 'absolute',
        right: 12,
    },
}));
